import { Box } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'
import { RecordsGridContainer } from 'ui/components/records-grid/recordsGrid.styles'

/* The shared records-grid theme, sized for the CPI details page. */
export const DevicesTableContainer = styled(RecordsGridContainer)`
  height: calc(100vh - 339px);
  padding: ${theme.spacing.medium}px ${theme.spacing.xSmall}px ${theme.spacing.medium}px ${theme.spacing.medium}px;

  .create-ticket-cta {
    &:hover:not(.Mui-disabled) {
      background: ${theme.colors.btnSecondaryHoverBg};
      border-color: ${theme.colors.btnSecondaryHoverBg};
      color: ${theme.colors.btnSecondaryText};
    }

    &.Mui-disabled {
      background: transparent;
      border-color: ${theme.colors.btnSecondaryDisabledBorder};
      color: ${theme.colors.btnSecondaryDisabledText};
    }
  }

  .exclusion-rule-cta:hover:not(.Mui-disabled) {
    background: ${theme.colors.buttonHollowHover};
    border-color: ${theme.colors.buttonHollowHover};
    color: ${theme.colors.surfaceContainerBackground};
    box-shadow: none;
  }
`

export const ManagementStatusWrapper = styled(Box)`
  background: transparent;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: ${theme.spacing.md}px;
  padding-right: ${theme.spacing.small}px;

  .controls-container {
    display: flex;
    align-items: center;
    gap: ${theme.spacing.md}px;
  }
`

export const ExclusionRulesButton = styled(Box)<{ disabled?: string; bordered?: string }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: ${theme.spacing.xSmall}px;
  height: 48px;
  padding: 0 ${theme.spacing.medium}px;
  border-radius: ${theme.attributes.borderRadius.tertiary};
  border: ${({ bordered, disabled }) =>
    bordered === 'true'
      ? `1px solid ${disabled === 'true' ? theme.colors.btnSecondaryDisabledText : theme.colors.cta}`
      : 'none'};
  color: ${({ disabled }) => (disabled === 'true' ? theme.colors.btnSecondaryDisabledText : theme.colors.cta)};
  font-family: ${theme.typography.fontFamily.primary};
  font-size: ${theme.typography.fontSize.large};
  font-weight: ${theme.typography.fontWeight.bold};
  line-height: 22px;
  cursor: ${({ disabled }) => (disabled === 'true' ? 'not-allowed' : 'pointer')};
  user-select: none;
  background: ${theme.colors.devicesExclusionBtnBg};
  white-space: nowrap;
  pointer-events: ${({ disabled }) => (disabled === 'true' ? 'none' : 'auto')};
  transition: background-color 120ms ease, color 120ms ease;

  &:hover {
    background: ${({ disabled }) => (disabled === 'true' ? theme.colors.devicesExclusionBtnBg : theme.colors.cta)};
    color: ${({ disabled }) =>
      disabled === 'true' ? theme.colors.btnSecondaryDisabledText : theme.colors.surfaceContainerBackground};
  }
`

export const SelectionActionBar = styled(Box)`
  position: fixed;
  bottom: 0;
  left: 72px;
  right: 0;
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${theme.spacing.small}px ${theme.spacing.medium}px;
  background: ${theme.colors.surfaceContainerBackground};
  border-top: 1px solid ${theme.colors.strokePrimary};
  box-shadow: ${theme.attributes.boxShadow.primary};

  .selection-count {
    font-family: ${theme.typography.fontFamily.primary};
    font-size: ${theme.typography.fontSize.large};
    line-height: 22px;

    .selection-count__label {
      color: ${theme.colors.dropdownLabel};
      font-weight: ${theme.typography.fontWeight.normal};
    }

    .selection-count__value {
      color: ${theme.colors.menuItemText};
      font-weight: ${theme.typography.fontWeight.normal};
    }
  }

  .selection-actions {
    display: flex;
    align-items: center;
    gap: ${theme.spacing.medium}px;
  }

  .selection-message {
    max-width: 560px;
    color: ${theme.colors.devicesSecondaryText};
    font-family: ${theme.typography.fontFamily.primary};
    font-size: ${theme.typography.fontSize.medium};
    line-height: 20px;
    text-align: right;
  }
`

export const HeaderInfoWrapper = styled(Box)`
  padding: ${theme.spacing.small}px ${theme.spacing.small}px ${theme.spacing.md}px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;

  padding-right: ${theme.spacing.small}px;

  .MuiTypography-root {
    color: ${theme.colors.dropdownLabel};
    font-family: ${theme.typography.fontFamily.primary};
    font-size: ${theme.typography.fontSize.large};
    font-style: normal;
    font-weight: ${theme.typography.fontWeight.normal};
    line-height: 22px;

    html[data-theme='light'] & {
      color: #5c5865;
    }

    span {
      color: ${theme.colors.menuItemText};
    }
  }
`
